import { BrowserRouter } from "react-router-dom";
import Main from "./Container/Main/Main";
function App() {
  return (
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  );
}

export default App;
